import React from "react";
import * as Mui from "@mui/material";
import { DashboardLayout } from "component/layout/dashboard";
import { OneCrmIframe } from "component/shared/iframe/onecrm";
import { PageProps } from "shared/page-props";
import * as Router from "react-router-dom";
import * as Icons from "react-feather";
import { FeatherIcon } from "component/shared/feather-icon";

interface Props extends PageProps, Router.RouteComponentProps {
}

class Component extends React.Component<Props> {

	public render() {
		const title = "Active Prospects";
		return (
			<DashboardLayout
				title={title}
				header={
					<Mui.Typography variant="h1">
						<FeatherIcon>
							<Icons.User />
						</FeatherIcon>
						{title}
					</Mui.Typography>
				}
				iframe={<OneCrmIframe url="/admin/prospects/prospects.aspx" />}
			/>
		);
	}

}

export const OneActiveProspectsPage = Component;